import {Button, Text, useColorModeValue} from "@chakra-ui/react";
import React from "react";
import {useLanguage} from "contexts/LanguageContext";

const LanguageToggle = ({secondary}) => {
    const {language, toggleLanguage} = useLanguage();
    const defaultColor = useColorModeValue("gray.600", "gray.200");
    const color = secondary ? "white" : defaultColor;

    return (
        <Button
            aria-label="Toggle sidebar language between English and Nepali"
            onClick={toggleLanguage}
            size="sm"
            minW={{base: "58px", md: "68px"}}
            variant="outline"
            color={color}
            borderColor={secondary ? "whiteAlpha.600" : "gray.200"}
            borderRadius="10px"
            px={{base: "4px", md: "8px"}}
            me="0px"
        >
            <Text fontWeight={language === "en" ? "bold" : "normal"}>EN</Text>
            <Text mx={{base: "3px", md: "5px"}}>|</Text>
            <Text fontWeight={language === "ne" ? "bold" : "normal"}>ने</Text>
        </Button>
    );
};

export default LanguageToggle;
